import React from 'react';
import {
  ManageAccountLink as Link,
  ManageAccountLinkWrapper as LinkWrapper,
} from './styles';

interface ManageAccountLinkProps {
  e2eId: string;
  url: string;
  label: string;
}

const ManageAccountLink: React.VFC<ManageAccountLinkProps> = ({
  e2eId,
  url,
  label,
}) => (
  <LinkWrapper>
    <Link size="base" data-ccx-e2e-id={e2eId} href={url}>
      {label}
    </Link>
  </LinkWrapper>
);

export default ManageAccountLink;
